module.exports = __webpack_public_path__ + "static/BigCaslonMedium-dde9e57518f9e9858483422e43cc3ad7.otf";